<template>
  <div class="dropdown-container messengerNotifications">
    <div class="title">
      <div>{{ meta.title }}</div>
    </div>
    <div v-if="gettingConversations && (!sortedConversations || !sortedConversations.length)" class="info-text">{{ meta.loading }}</div>
    <div v-else-if="!gettingConversations && (!sortedConversations || !sortedConversations.length)" class="dropdown-empty info-text">
      {{ meta.empty }}
    </div>
    <div>
      <div class="item-container" v-if="sortedConversations && sortedConversations.length">
        <div v-for="(preview, i) in sortedConversations" :key="i" @click="$emit('openConversation', preview.conversationID)" class="dropdown-item">
          <div class="details">
            <div class="imageContainer">
              <ik-image
                loading="lazy"
                :transformation="[{ height: 500, width: 500 }]"
                v-if="preview && preview.partner && preview.partner.profileImageUrl"
                :src="preview.partner.profileImageUrl"
                class="image"
              />
              <div v-else class="image smallBorder">
                <IconBase icon-name="profile" iconColor="#333" viewBox="0 0 32 32" width="100%" height="100%" strokeWidth="0px"
                  ><IconProfileImg
                /></IconBase>
              </div>
            </div>
            <div class="previewInfo">
              <div class="previewName displayName">
                {{ preview.partner.displayName }}
              </div>
              <div :class="preview.messagePreview.read ? 'read' : 'unread'">
                <div class="previewText" v-html="preview.messagePreview.preview"></div>
              </div>
              <!-- atm invisible because below the next box or smth -->
              <div class="previewText">{{ formattedPreviewDate }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="infinite-container">
        <infinite-loading force-use-infinite-wrapper @infinite="loadMoreConversations" spinner="spiral">
          <template v-slot:spinner>Loading...</template>
          <template v-slot:no-more>All loaded.</template>
          <template v-slot:no-results>No conversations</template>
          <template v-slot:error>Error</template>
        </infinite-loading>
      </div>
    </div>
    <div class="expand">
      <div @click="$emit('openMessenger', true)" class="expand-button">
        {{ meta.expand }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import InfiniteLoading from "vue-infinite-loading";

import IconBase from "@/components/IconBase";
import IconProfileImg from "@/components/SVG/IconProfileImg";

import messengerAPI from "@/api/messengerAPI";
import { hr_minutes } from "@/utilities/dateFormatter";

const NR_CONVOS_TO_LOAD = 4;

export default {
  name: "MessengerNotifications",
  components: {
    IconBase,
    IconProfileImg,
    InfiniteLoading,
  },
  props: {
    userID: {
      type: String,
    },
  },
  data() {
    return {
      gettingConversations: false,
      meta: {
        title: "Messenger",
        loading: "Loading conversations...",
        empty: "You have no conversations.",
        expand: "Expand Messenger",
        load: "Load more",
        allLoaded: "No more to load",
      },
    };
  },
  computed: {
    ...mapState({
      prefer24HourFormat: (state) => state.cofocusPreferences.calendarPreferences.prefer24HourFormat,
      oldestLoadedDateMS: (state) => state.messages.oldestLoadedDateMS,
      allConvoPreviewsLoaded: (state) => state.messages.allConvoPreviewsLoaded,
    }),
    sortedConversations() {
      console.log("@getSortedConversations: ", this.$store.getters["messages/getSortedConversations"]);
      console.log("typeof: ", typeof this.$store.getters["messages/getSortedConversations"]);
      console.log("length: ", this.$store.getters["messages/getSortedConversations"].length);
      console.log("boolean: ", this.$store.getters["messages/getSortedConversations"] ? true : false);
      return this.$store.getters["messages/getSortedConversations"];
    },
  },
  methods: {
    async loadMoreConversations($state) {
      this.gettingConversations = true;

      if (this.allConvoPreviewsLoaded) {
        $state.complete();
      } else {
        const result = await messengerAPI.getConversations(this.oldestLoadedDateMS, 0, NR_CONVOS_TO_LOAD);
        console.log("@getConversations result: ", result);
        if (result !== null) {
          await this.$store.dispatch("messages/addConversations", {
            userID: this.userID,
            conversations: result.conversations,
          });
          if (result.allLoaded) {
            this.$store.commit("messages/SET_ALL_CONVOS_LOADED", true);
          }
        } else {
          console.error("HAHA FAIL no previews for youuuu ");
        }
        $state.loaded();
      }

      this.gettingConversations = false;
    },
    formattedPreviewDate() {
      return hr_minutes(this.preview.date, this.prefer24HourFormat);
    },
  },
};
</script>

<style scoped>
@import "./styles/Dropdown.css";
.messengerNotifications {
  left: calc((-241px) / 2) !important;
}
/* ==== NEW ==== */
.unread {
  font-weight: bold;
}
.read {
  font-weight: 400;
}
/* ==== NEW END ==== */

.dropdown-item .displayName {
  margin-left: 0px;
}

.previewInfo {
  padding-top: 5px;
  box-sizing: border-box;
  text-overflow: ellipsis !important;
  overflow: hidden !important;
  white-space: nowrap !important;
  width: 175px !important;
  height: 42px !important;
}

.previewText {
  color: #323333 !important;
  padding: 4px 0px !important;
  padding-bottom: 0px !important;
  box-sizing: border-box;
  text-overflow: ellipsis !important;
  overflow: hidden !important;
  white-space: nowrap !important;
  width: 155px !important;
  font-size: 14px !important;
  height: 19px !important;
}

/* https://stackoverflow.com/questions/48331383/css-styles-not-being-applied-to-html-within-a-vue-component */
.previewText >>> p,
.previewText >>> span {
  text-overflow: ellipsis !important;
  overflow: hidden !important;
  white-space: nowrap !important;
  width: 155px !important;
  background-color: transparent !important;
}

.previewText >>> ol,
.previewText >>> ul {
  padding-left: 24px;
  /* line-height: 21px; */
  padding-top: 0px;
  margin-top: 0px;
  margin-bottom: 0px;
}

.previewText >>> ol {
  list-style-type: decimal !important;
}

.previewText >>> ul {
  list-style-type: disc !important;
}

.previewText >>> li {
  padding-left: 0px;
  padding-top: 0px;
}

.previewText >>> i {
  font-style: italic;
}

.previewText >>> strong {
  font-weight: bold;
}

/* todo maybe eliminate */
.previewName {
  text-overflow: ellipsis !important;
  overflow: hidden !important;
  white-space: nowrap !important;
  width: 155px !important;
}
.previewName:hover {
  text-decoration: none;
}

.imageContainer {
  margin-right: 10px;
  display: flex;
  box-sizing: border-box;
}
.infinite-status-prompt {
  display: none !important;
}
</style>
